import {
  ASSET_GROUP_LIST, ASSET_GROUP_LIST_SUCCESS, ASSET_GROUP_LIST_FAILURE,
  ASSET_GROUP_DATA, ASSET_GROUP_DATA_SUCCESS, ASSET_GROUP_DATA_FAILURE,
  ASSET_GROUP_CREATE, ASSET_GROUP_CREATE_SUCCESS, ASSET_GROUP_CREATE_FAILURE,
  ASSET_GROUP_UPDATE, ASSET_GROUP_UPDATE_SUCCESS, ASSET_GROUP_UPDATE_FAILURE,
  ASSET_GROUP_DELETE, ASSET_GROUP_DELETE_SUCCESS, ASSET_GROUP_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  assetGroupList: [], assetGroupListLoading: false, assetGroupListError: null,
  assetGroupData: [], assetGroupDataLoading: false, assetGroupDataError: null,
  assetGroupCreate: [], assetGroupCreateLoading: false, assetGroupCreateError: null,
  assetGroupUpdate: [], assetGroupUpdateLoading: false, assetGroupUpdateError: null,
  assetGroupDelete: [], assetGroupDeleteLoading: false, assetGroupDeleteError: null,
};

const AssetGroup = (state = initialState, action) => {
  switch (action.type) {
    case ASSET_GROUP_LIST:         return { ...state, assetGroupListLoading: true, assetGroupListError: null };
    case ASSET_GROUP_LIST_SUCCESS: return { ...state, assetGroupList: action.payload, assetGroupListLoading: false, assetGroupListError: null };
    case ASSET_GROUP_LIST_FAILURE: return { ...state, assetGroupList: [], assetGroupListLoading: false, assetGroupListError: action.payload };

    case ASSET_GROUP_DATA:         return { ...state, assetGroupDataLoading: true, assetGroupDataError: null };
    case ASSET_GROUP_DATA_SUCCESS: return { ...state, assetGroupData: action.payload, assetGroupDataLoading: false, assetGroupDataError: null };
    case ASSET_GROUP_DATA_FAILURE: return { ...state, assetGroupData: [], assetGroupDataLoading: false, assetGroupDataError: action.payload };

    case ASSET_GROUP_CREATE:         return { ...state, assetGroupCreateLoading: true, assetGroupCreateError: null };
    case ASSET_GROUP_CREATE_SUCCESS: return { ...state, assetGroupCreate: action.payload, assetGroupCreateLoading: false, assetGroupCreateError: null };
    case ASSET_GROUP_CREATE_FAILURE: return { ...state, assetGroupCreate: [], assetGroupCreateLoading: false, assetGroupCreateError: action.payload };

    case ASSET_GROUP_UPDATE:         return { ...state, assetGroupUpdateLoading: true, assetGroupUpdateError: null };
    case ASSET_GROUP_UPDATE_SUCCESS: return { ...state, assetGroupUpdate: action.payload, assetGroupUpdateLoading: false, assetGroupUpdateError: null };
    case ASSET_GROUP_UPDATE_FAILURE: return { ...state, assetGroupUpdate: [], assetGroupUpdateLoading: false, assetGroupUpdateError: action.payload };

    case ASSET_GROUP_DELETE:         return { ...state, assetGroupDeleteLoading: true, assetGroupDeleteError: null };
    case ASSET_GROUP_DELETE_SUCCESS: return { ...state, assetGroupDelete: action.payload, assetGroupDeleteLoading: false, assetGroupDeleteError: null };
    case ASSET_GROUP_DELETE_FAILURE: return { ...state, assetGroupDelete: [], assetGroupDeleteLoading: false, assetGroupDeleteError: action.payload };

    default: return state;
  }
};

export default AssetGroup;
